import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { EnrollmentType, StudentStatisticsQueryParams, StudentStatisticsResponse } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { ENROLLMENTS, ENROLLMENTS_BY_STUDENT, ENROLLMENTS_STUDENTS_STATS } from "../../../utils/constants";

export const getEnrollments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),

    });
    const url = `${ENROLLMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<EnrollmentType>>(url)
};
export const getEnrollmentsByStudent = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),

    });
    const url = `${ENROLLMENTS_BY_STUDENT}?${queryParams.toString()}`;
    return await get<PagedResultsType<EnrollmentType>>(url)
};

export const getStudentStatistics = async (filters: StudentStatisticsQueryParams) => {
    const queryParams = new URLSearchParams(
        Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== "")
            .reduce((acc, [key, value]) => {
                acc[key] = typeof value === "boolean" ? (value ? "1" : "0") : value.toString();
                return acc;
            }, {} as Record<string, string>)
    );

    const response = await get<StudentStatisticsResponse[]>(`${ENROLLMENTS_STUDENTS_STATS}?${queryParams.toString()}`);
    return response;
};
